import React from 'react';
import { Layout, Rocket, Code2, Cpu, Globe, CheckCircle2 } from 'lucide-react';
import './WebsiteDevelopment.css';
import Hero from '../../components/Hero/Hero';
import FAQ from '../../components/FAQ/FAQ';
import CTASection from '../../components/CTA/CTA';
import Footer from '../../components/Footer/Footer';

export default function WordPressReact() {
  const features = [
    {
      icon: <Layout size={24} />,
      title: 'Headless CMS',
      text: 'Manage content with the familiarity of WordPress while using React for a lightning-fast frontend.'
    },
    {
      icon: <Rocket size={24} />,
      title: 'Superior Speed',
      text: 'React-powered sites load instantly, improving SEO rankings and user retention rates.'
    },
    {
      icon: <Code2 size={24} />,
      title: 'Custom Logic',
      text: 'Implement complex interactive features that standard WordPress themes simply cannot handle.'
    }
  ];

  const faqItems = [
    {
      question: 'Why combine WordPress with React?',
      answer: 'WordPress provides an excellent editor experience for non-technical users, while React offers a modern, high-performance user interface.'
    },
    {
      question: 'Is it better for SEO?',
      answer: 'Yes. Fast-loading single-page applications (SPAs) built with React/Next.js are favored by Google search algorithms.'
    }
  ];

  return (
    <article className="website-page">
      <Hero 
        eyebrow="WordPress & React"
        title={<>Hybrid <span className="hero-accent">Performance</span> for the Modern Web.</>}
        description="The best of both worlds. We combine the world's most popular CMS with the performance of React to build digital experiences that convert."
        primaryAction={{ label: "View Portfolio", link: "#features" }}
        stats={[
          { label: "Performance", value: "90+ Lighthouse Score" },
          { label: "Stability", value: "Enterprise Grade" }
        ]}
      />

      <section className="section" id="features">
        <div className="section-heading">
          <span className="eyebrow">Platform Benefits</span>
          <h2>Why choose WordPress & React?</h2>
          <p>We build scalable web applications that leverage the content management power of WordPress and the flexibility of React.</p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="info-row">
          <div className="info-copy">
            <h3>Seamless Content Management</h3>
            <p>Your team keeps using the WordPress dashboard they know, while your customers experience a high-speed React application.</p>
            <ul className="check-list">
              <li><CheckCircle2 size={18} /> Instant page transitions</li>
              <li><CheckCircle2 size={18} /> Real-time content updates</li>
              <li><CheckCircle2 size={18} /> Custom Gutenberg blocks</li>
            </ul>
          </div>
          <div className="info-media">
            <img src="/images/wordpress-react/development.jpg" alt="Development" />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <span className="eyebrow">Deep Dive</span>
          <h2>Hybrid Questions.</h2>
        </div>
        <FAQ items={faqItems} />
      </section>

      <CTASection title="Ready to upgrade your web presence?" />
      <Footer />
    </article>
  );
}
